import React, { useEffect, useState } from 'react';
import { Copy, ExternalLink, Link, X } from 'lucide-react';

export const ClientShareDialog = ({ client, token, apiFetch, Modal, Btn, onClose }) => {
  const [share, setShare] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);
  const link = share ? `${window.location.origin}/?client-share=${encodeURIComponent(share.token)}` : '';
  const generate = async () => {
    setBusy(true); setError('');
    try { setShare(await apiFetch(`/clients/${client.id}/share`, { method: 'POST' }, token)); setCopied(false); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  const revoke = async () => {
    setBusy(true); setError('');
    try { await apiFetch(`/clients/${client.id}/share`, { method: 'DELETE' }, token); setShare(null); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <Modal open onClose={onClose} title="Share Client" width="max-w-md">
    <div className="share-modal-body" data-testid="share-client-modal">
      <strong data-testid="share-client-name">{client.name}</strong>
      {error && <div className="alert-error" role="alert" data-testid="share-client-error">{error}</div>}
      {share && <>
        <div className="share-link-box"><span className="share-link-url" data-testid="share-client-link">{link}</span></div>
        <span className="text-muted" data-testid="share-client-expiry">Expires {new Date(share.expires_at).toLocaleDateString()}</span>
      </>}
      <div className="share-modal-actions">
        {!share ? <Btn onClick={generate} disabled={busy} data-testid="share-client-generate-btn"><Link size={14} /> Create Share Link</Btn> : <>
          <Btn data-testid="share-client-copy-btn" onClick={async () => { try { await navigator.clipboard.writeText(link); setCopied(true); } catch { setError('Could not copy link'); } }}><Copy size={14} />{copied ? 'Copied!' : 'Copy Link'}</Btn>
          <Btn variant="outline" onClick={() => window.open(link, '_blank', 'noopener,noreferrer')} data-testid="share-client-open-btn"><ExternalLink size={14} /> View Client</Btn>
        </>}
        <Btn variant="outline" onClick={revoke} disabled={busy} data-testid="share-client-revoke-btn"><X size={14} /> Revoke All Links</Btn>
      </div>
    </div>
  </Modal>;
};

export const PublicClientPage = ({ shareToken, apiFetch }) => {
  const [client, setClient] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    apiFetch(`/public/client-shares/${encodeURIComponent(shareToken)}`)
      .then(data => { if (active) setClient(data); })
      .catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, [shareToken, apiFetch]);
  return <main className="public-page" data-testid="public-client-page">
    {error ? <p role="alert" data-testid="public-client-error">{error}</p> : !client ? <p role="status" data-testid="public-client-loading">Loading…</p> : <>
      <h1 className="page-title font-manrope" data-testid="public-client-name">{client.name}</h1>
      {['role', 'email', 'phone'].map(key => client[key] && <div className="public-detail-row" key={key} data-testid={`public-client-${key}`}>{client[key]}</div>)}
      {client.custom_fields.map(field => field.value !== '' && <div className="public-detail-row" key={field.id} data-testid={`public-client-field-${field.id}`}><strong>{field.label}</strong><span>{String(field.value)}</span></div>)}
    </>}
  </main>;
};